// extracted by mini-css-extract-plugin
export default {"spinner-container":"LoadingSpinner_spinner-container__oCUtg","spinner":"LoadingSpinner_spinner__+wPdQ","spin":"LoadingSpinner_spin__XnuOF"};